export default __webpack_public_path__ + "img/dprrvuNN.586b3129.svg";